// extracted by mini-css-extract-plugin
export default {"image":"t2-z","loaded":"u2-z"};